import { render, staticRenderFns } from "./ParallaxSection.vue?vue&type=template&id=1ffc89b6"
import script from "./ParallaxSection.vue?vue&type=script&lang=js"
export * from "./ParallaxSection.vue?vue&type=script&lang=js"
import style0 from "./ParallaxSection.vue?vue&type=style&index=0&id=1ffc89b6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports